/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://b40i1cg0zl.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "MyAMZPrepStoreAPI",
            "endpoint": "https://j43ouj0lxl.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "MyAMZPrepStripeWebhookAPI",
            "endpoint": "https://vuxib9epl7.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "myamzprepfixapi",
            "endpoint": "https://dqhq98v3ce.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:81142bbc-aa34-47e8-b2b5-bab04f44e1e4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_66heM4zYh",
    "aws_user_pools_web_client_id": "2dkimpnpmeamj0o2i8msldlmot",
    "oauth": {
        "domain": "myamzprepfix-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.myamzprep.com/",
        "redirectSignOut": "https://www.myamzprep.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AmazonPaidForIt_Leftovers-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "myamzprepfix25e8881e9f3047b2a82d2ab481ff0418200130-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
